exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-day{border:1px solid #000}@media screen and (min-width:992px){.btn-day{width:120px}}", ""]);

// exports
